import { changeAmount, selectOrderId } from '@entities/cart';
import type { AxiosError } from 'axios';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { useAppDispatch, useAppSelector, useDialog } from '@shared/hooks';

import { shopService } from '@src/library/api/shopService';

export const usePromocode = () => {
	const dispatch = useAppDispatch();
	const [code, setCode] = useState<string>('');
	const [status, setStatus] = useState('idle');
	const id = useAppSelector(selectOrderId);

	const { notification } = useDialog();

	const apply = async () => {
		let message = '';
		try {
			setStatus('loading');
			const response = await shopService.applyPromo(id, code);
			message = `Промокод ${code} успешно применен`;
			dispatch(changeAmount({ amount: response.data.amount }));
			setStatus('idle');
		} catch (error) {
			setStatus('error');
			const err = error as AxiosError;

			if (err.response?.data === 'Revoked promocode!') {
				message = `Промокод ${code} устарел`;
			} else {
				message = `Не удалось применить промокод ${code}`;
			}
		}

		notification({
			title: ``,
			text: message,
			confirmText: 'Ок',
		});
	};

	return {
		code,
		setCode,
		status,
		apply,
	};
};

export const usePromocodeForm = () => {
	interface IPromoForm {
		promo: string;
	}

	const defaultValues: IPromoForm = {
		promo: '',
	};

	const methods = useForm<IPromoForm>({ defaultValues, mode: 'onChange' });

	return { methods };
};
